import styled from "styled-components";
import { Link } from "react-router-dom";

export const HomePageWrapper = styled.section`
  width: 100%;
  height: 100%;
  padding: 5rem 0;
  text-align: center;
`;

export const PageTitle = styled.h1`
  margin: 2rem;
  font-size: 4.8rem;
  font-weight: 600;
`;

export const PageSubTitle = styled.h3`
  font-size: 3.2rem;
  margin: 2.8rem;
`;

export const Description = styled.p`
  margin: 4rem;
  font-size: 2.4rem;
  line-height: 1.3;
`;

export const IntroduceImg = styled.img`
  display: block;
  margin: 5rem auto;
  width: 80%;
  max-width: 1200px;
`;

export const WaringMessage = styled.p`
  color: crimson;
  font-size: 2rem;
  line-height: 1.2;
`;

export const LinkWarpper = styled.div`
  margin: 4rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40rem;
  height: 5rem;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  width: 20rem;
  height: 5rem;
  font-size: 1.8rem;
  background-color: transparent;
  outline: none;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  & + & {
    margin-left: 2rem;
  }
  &:visited {
    color: black;
  }
  &:hover {
    color: rgb(177, 177, 177);
    border: 1px solid rgb(177, 177, 177);
  }
`;
